import { Button, styled } from "@mui/material";
import { ICustomButtonProps, getSizeStyles } from "./CustomBtnResources";

// PrimaryButton.js
const PrimaryButton = ({
  disabled,
  children,
  onClick,
  style,
  size = "large",
  nativeType,
  type = "primary",
  loading = false,
  loadingText = "Loading...",
  preImg,
  postImg,
}: ICustomButtonProps) => {
  const PryButton = styled(Button)`
    && {
      text-transform: none;
      border-radius: 30px;
      font-weight: 500;
      background-color: #fdd649;
      color: #121212;
      border: none;
      width: auto;
      gap: 8px;
      padding: ${getSizeStyles(size, type).padding};
      font-size: ${getSizeStyles(size, type).fontSize};
      line-height: ${getSizeStyles(size, type).lineHeight};
      &:hover {
        background-color: #fee38b;
        color: #121212;
      }
      &:active {
        background-color: #feefc3;
        color: #696969;
      }
      &:disabled {
        background-color: #292929 !important;
        color: #696969;
      }
    }
  `;

  return (
    <PryButton
      type={nativeType}
      disabled={disabled}
      onClick={onClick}
      style={style}
    >
      {!loading && preImg && typeof preImg === "string" ? (
        <img
          src={preImg}
          alt="preImg"
          style={{ display: "flex", marginRight: 8 }}
          width={size === "large" || type === "onBoarding" ? 24 : 18}
          height={size === "large" || type === "onBoarding" ? 24 : 18}
        />
      ) : (
        !loading &&
        preImg && <div style={{ display: "flex", marginLeft: 8 }}>{preImg}</div>
      )}
      {!loading ? children : loadingText}
      {!loading && postImg && typeof postImg === "string" ? (
        <img
          src={postImg}
          style={{ display: "flex", marginLeft: 8 }}
          alt="postImg"
          width={size === "large" ? 24 : 18}
          height={size === "large" ? 24 : 18}
        />
      ) : (
        !loading &&
        postImg && (
          <div style={{ display: "flex", marginLeft: 8 }}>{postImg}</div>
        )
      )}
    </PryButton>
  );
};

export default PrimaryButton;
